export const DELETE_CONFIRMATION_QUESTION =
  "Are you sure you want to delete this employee?";
